<template>
  <div
    class="acceleration-factor"
    :class="{ 'acceleration-factor--with-diagnosis': isWithDiagnosis }"
  >
    <label class="acceleration-factor__title">
      {{ $t('engineering.isolation-aging.acceleration-factor') }}
    </label>
    <div
      class="acceleration-factor__value"
      :class="valueClass"
    >
      <s-number
        :fallback-value="numberFallback"
        :value="data.value"
      />
    </div>
    <div class="acceleration-factor__period-box">
      <label class="acceleration-factor__period-box-title">
        {{ $t('engineering.isolation-aging.accumulated-acceleration-factor') }}
      </label>
      <div class="acceleration-factor__period-box-field">
        <span class="text-wrap mr-2">
          {{ $t('fields.engineering.isolation-aging.from-period-fixed') }}
        </span>
        <span class="acceleration-factor__period-box-value">
          <s-number
            :fallback-value="numberFallback"
            :value="data.fixedPeriod"
          />
        </span>
      </div>
      <div class="acceleration-factor__period-box-field">
        <span class="text-wrap mr-2">
          {{ $t('fields.engineering.isolation-aging.from-period-movable') }}
        </span>
        <span class="acceleration-factor__period-box-value">
          <s-number
            :fallback-value="numberFallback"
            :value="data.movingPeriod"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { AccelerationFactorSituation } from 'sigma-mappings';

export default {
  name: 'AccelerationFactor',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    numberFallback: '-',
  }),
  computed: {
    valueClass() {
      if (!this.data.situation) return '';
      return this.isWithDiagnosis
        ? 'acceleration-factor__value--with-diagnosis'
        : 'acceleration-factor__value--normal';
    },
    isWithDiagnosis() {
      return this.data.situation === AccelerationFactorSituation.WITH_DIAGNOSIS;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.acceleration-factor
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-between
  border: 1px solid $color-border-gray
  border-radius: 3px
  padding: 8px
  &--with-diagnosis
    border: none
    box-shadow: 0 0 3px var(--color-danger-light),
    inset 0 0 3px var(--color-danger-light) !important
  &__value
    display: flex
    justify-content: center
    align-items: center
    min-height: 50px
    min-width: 110px
    margin-bottom: 10px
    color: var(--font-color-primary)
    background-color: var(--color-background-dark)
    font-weight: bold
    font-size: 1.1em
    &--normal
      color: white
      background-color: var(--color-primary)
    &--with-diagnosis
      color: white
      background-color: var(--color-danger)
  &__period-box
    padding: 5px
    width: 100%
    background-color: var(--color-background-dark)
    border: 1px solid $color-background-gray
    border-radius: 3px
    font-size: .9em
  &__period-box-field
    display: flex
    justify-content: flex-end
    align-items: center
    text-align: right
    flex-wrap: nowrap
    margin-bottom: 8px
  &__period-box-value
    display: inline-flex
    align-items: center
    justify-content: flex-end
    background-color: var(--color-background-light)
    opacity: .7
    padding: 3px 5px
    text-align: right
    min-width: 70px

.manage-fonts_18px
  .acceleration-factor
    &__period-box-value
      min-width: 85px
.manage-fonts_16px
  .acceleration-factor
    &__period-box-value
      min-width: 80px
</style>
